import { createContext } from "react";
import { DispatchNotificationAction, NotificationsState } from "@States/notifications";

export interface NotificationsContextType extends NotificationsState {
  dispatchNotification: DispatchNotificationAction;
}

const NotificationsContext = createContext<NotificationsContextType>(
  {} as NotificationsContextType
);

export default NotificationsContext;
